"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = require("../../core/helper");
var abstract_1 = require("./abstract");
var base_1 = __importDefault(require("../base"));
var wo_file_1 = __importDefault(require("./wo-file"));
var getFileId = function () {
    var fid = (0, helper_1.getParams)(window.location.href).fid;
    return fid;
};
var getOfficeType = function () {
    if (base_1.default.isKdocs) {
        return wo_file_1.default.getOfficeType();
    }
    var officeType = (0, helper_1.getParams)(window.location.href).officeType;
    return officeType || abstract_1.OfficeType.unknown;
};
var getDocumentInfo = function () { return ({}); };
var addDocumentActivedListener = function () {
    // do nothing
};
var removeDocumentActivedListener = function () {
    // do nothing
};
var addDocBecomeCloudDocListener = function () {
    // do nothing
};
var removeDocBecomeCloudDocListener = function () {
    // do nothing
};
var file = {
    getFileId: getFileId,
    getOfficeType: getOfficeType,
    getDocumentInfo: getDocumentInfo,
    addDocumentActivedListener: addDocumentActivedListener,
    removeDocumentActivedListener: removeDocumentActivedListener,
    addDocBecomeCloudDocListener: addDocBecomeCloudDocListener,
    removeDocBecomeCloudDocListener: removeDocBecomeCloudDocListener
};
exports.default = file;
